var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoComuniteCaa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 99,
    viewBox: "0 0 132 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92278 51.6688L0 40.0225L66.9048 0L132 40.0688L124.932 51.6226L66.8061 15.8453L6.92278 51.6688Z",
    fill: "#434341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3914 79.4244C37.0463 72.6795 37.2486 65.3059 39.9599 58.7007C42.6712 52.0954 47.7033 46.7174 54.1026 43.5855C60.5019 40.4536 67.8239 39.7855 74.6814 41.7077C81.5388 43.6299 87.4554 48.0089 91.3099 54.0151C95.1645 60.0212 96.6894 67.2372 95.5956 74.2959C94.5019 81.3546 90.8655 87.7655 85.3754 92.3142C79.8854 96.8628 72.923 99.2331 65.8076 98.9759C58.6921 98.7188 51.9178 95.852 46.7682 90.9188L28.1385 97.805L39.3914 79.4244Z",
    fill: "#434341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoComuniteCaa);
export default __webpack_public_path__ + "static/media/logoComuniteCAA.8b55e13d5bdff3fd3315e757ad895138.svg";
export { ForwardRef as ReactComponent };